/** `const tx = useSketchText()`: the Sketch's text helper (text.ts) in the user's language; `<Msg id values>` for a
 * message with tags (`<kbd>P</kbd>`, `<b>…</b>`): the values give each tag its element. */
import { createElement, useMemo, type ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import type { MessageKey } from "../i18n/keys";
import { textOf, type Text } from "./text.ts";

export function useSketchText(): Text {
  const intl = useIntl();
  return useMemo(() => textOf(intl), [intl]);
}

export function Msg({ id, values }: { id: MessageKey; values?: Record<string, ReactNode | ((chunks: ReactNode[]) => ReactNode)> }) {
  return createElement(FormattedMessage, { id, values: values as never });
}

/** The `<kbd>` tag of a message: a key cap. */
export const kbd = (chunks: ReactNode[]) => createElement("kbd", { className: "sk-kbd" }, ...chunks);
